import { render, staticRenderFns } from "./OneTab.vue?vue&type=template&id=d20f0534&scoped=true&lang=pug&"
import script from "./OneTab.vue?vue&type=script&lang=ts&"
export * from "./OneTab.vue?vue&type=script&lang=ts&"
import style0 from "./OneTab.vue?vue&type=style&index=0&id=d20f0534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20f0534",
  null
  
)

export default component.exports